<template>
  <div id="app">
    <app-navbar
      @changeLanguage="changeLanguage"
      @login="login"
      @logout="logout"
      @openProfile="openProfile"
      :activeLanguage="activeLanguage"
      :hasMenu="true"
      :canSignIn="false"
      :loggedIn="loggedIn"
      :showMenu.sync="showMenu"
      :profile="profile"
      :isAdmin="isAdmin"
    >
      <template v-slot:navbar-start-buttons>
        <router-link
          to="/library"
          class="navbar-item is-size-7 has-text-weight-bold"
          v-t="'Route.library'"
        ></router-link>
      </template>
    </app-navbar>
    <transition name="fade" mode="out-in">
      <router-view :key="$route.fullPath"></router-view>
    </transition>
    <app-menu
      :show="showMenu"
      class="has-text-white is-hidden-mobile"
    ></app-menu>
    <simplert></simplert>
    <vue-snotify></vue-snotify>
    <footer>
      <cookie-law
        mmessage="$t('App.cookie_message')"
        :buttonText="$t('App.cookie_button_accept')"
      >
        <div slot="message">
          <i18n path="App.cookie_message" tag="p">
            <a :href="cookieUrl" target="_blank">{{
              $t("App.cookie_message_term")
            }}</a>
          </i18n>
        </div>

        <!--div slot-scope="props">
          <button class="button skew" @click="props.accept">
            <span>I accept</span>
          </button>
          <p>
            This site uses 🍪
          </p>
          <button class="button skew" @click="props.close">
            <span>Ignore me</span>
          </button>
        </div-->
      </cookie-law>
    </footer>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import AppMenu from 'mschools-components/src/components/AppMenu'
import AppNavbar from 'mschools-components/src/components/AppNavbar'
import CookieLaw from 'vue-cookie-law'
import _ from 'underscore'
export default {
  components: { AppMenu, AppNavbar, CookieLaw },
  mounted () {
    /* this.$router.replace({
      query: { lang: this.$store.getters.activeLanguage }
    }) */
    this.loggedIn &&
          this.getProfile({
            params: { access_token: sessionStorage.getItem('token') }
          })
    this.$store.dispatch('fetchPartners')
  },
  data () {
    return {
      showMenu: false,
      cookieUrl: process.env.VUE_APP_COOKIE_URL
    }
  },
  computed: {
    ...mapState({
      loggingIn: state => state.Auth.pending,
      loggedIn: state => state.Auth.isLoggedIn,
      availableLanguages: state => state.availableLanguages,
      profile: state => state.Auth.profile
    }),
    ...mapGetters(['activeLanguage']),
    isAdmin: function () {
      return _.contains(this.$store.getters.userRoles, 'administrators')
    }
  },
  watch: {
    loggedIn: function (future, past) {
      if (future === true) {
        this.getProfile({
          params: { access_token: sessionStorage.getItem('token') }
        })
      } else {
        this.$router.push('/')
      }
    },
    profile () {
      if (!_.isEmpty(this.profile)) {
        this.$ga.set('userId', this.profile.id)
      }
    }
  },
  methods: {
    ...mapActions([
      'login',
      'logout',
      'getProfile',
      'checkLogin'
    ]),
    triggerLogout: function () {
      this.logout()
    },
    changeLanguage (newLang) {
      this.$store.dispatch('CHANGE_ACTIVE_LANGUAGE', newLang)
    },
    openProfile () {
      window.open(
        `${process.env.VUE_APP_OAUTH_URL}/api/${
          this.activeLanguage
        }/profileEdit?access_token=${sessionStorage.getItem('atoken')}`
      )
    }
  },
  metaInfo: {
    // Children can override the title.
    title: 'mSTEAM',
    // Result: My Page Title ← My Site
    // If a child changes the title to "My Other Page Title",
    // it will become: My Other Page Title ← My Site
    titleTemplate: '%s by mSchools',
    // Define meta tags here.
    meta: [
      { 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      // { name: 'description', content: 'I have things here on my site.' },
      { property: 'og:title', content: 'mSTEAM by mSchools' },
      { property: 'og:site_name', content: 'mSTEAM' },
      // The list of types is available here: http://ogp.me/#types
      { property: 'og:type', content: 'website' },
      // Should the the same as your canonical link, see below.
      {
        property: 'og:url',
        content: 'https://www.msteam.mschools.com'
      },
      {
        property: 'og:image',
        content: 'https://www.my-site.com/my-special-image.jpg'
      },
      // Often the same as your meta description, but not always.
      { property: 'og:description', content: 'mSTEAM by mSchools' },

      // Twitter card
      // { name: 'twitter:card', content: 'summary' },
      /* {
        name: 'twitter:site',
        content: 'https://www.my-site.com/my-special-page'
      }, */
      // { name: 'twitter:title', content: 'My Page Title ← My Site' },
      /* {
        name: 'twitter:description',
        content: 'I have things here on my site.'
      },
      { name: 'twitter:creator', content: '@alligatorio' },
      {
        name: 'twitter:image:src',
        content: 'https://www.my-site.com/my-special-image.jpg'
      }, */

      // Google / Schema.org markup:
      { itemprop: 'name', content: 'mSTEAM by mSchools' },
      { itemprop: 'description', content: 'mSTEAM by mSchools' },
      {
        itemprop: 'image',
        content: 'https://www.my-site.com/my-special-image.jpg'
      }
    ]
  }
}
</script>
<style lang="scss">
@import "sass/msteam-style";
@import "~bulma/bulma";
@import "~animate.css";
@import "~vue-snotify/styles/material";
@import "~bulma-calendar/src/sass/index.sass";
.VueCarousel-wrapper {
  max-height: 560px !important;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(30px, 0);
  transform: translate(30px, 0);
}
.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-30px, 0);
  transform: translate(-30px, 0);
}

@include until($tablet) {
  .navbar.has-shadow {
    box-shadow: unset;
  }

  .navbar-menu.is-active {
    background-color: #063f5e;
    .navbar-item {
      color: white;
      &.is-active {
        background-color: $primary;
      }
    }
  }
}
</style>
